var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":_vm.absolute,"value":_vm.isLoading,"opacity":_vm.opacity,"z-index":_vm.zIndex}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }